import login from '@/locales/pl/login.json'
import label from '@/locales/pl/label.json'
import placeholder from '@/locales/pl/placeholder.json'
import button from '@/locales/pl/button.json'
import validation from '@/locales/pl/validation.json'
import status from '@/locales/pl/status.json'
import externalForm from '@/locales/pl/externalForm.json'
import home from '@/locales/pl/home.json'
import footer from '@/locales/pl/footer.json'
import childrenList from '@/locales/pl/childrenList.json'
import errorPages from '@/locales/pl/errorPages.json'
import modal from '@/locales/pl/modal.json'
import childCard from '@/locales/pl/childCard.json'
import document from '@/locales/pl/document.json'
import paymentsList from '@/locales/pl/paymentsList.json'
import paymentCard from '@/locales/pl/paymentCard.json'
import successCard from '@/locales/pl/successCard.json'
import filters from '@/locales/pl/filters.json'
import comment from '@/locales/pl/comment.json'
import publicCoordinatorQuestionnaire from '@/locales/pl/publicCoordinatorQuestionnaire.json'

export default {
  login,
  label,
  placeholder,
  button,
  validation,
  status,
  externalForm,
  home,
  footer,
  childrenList,
  errorPages,
  modal,
  childCard,
  document,
  paymentsList,
  paymentCard,
  successCard,
  filters,
  comment,
  publicCoordinatorQuestionnaire
}
